/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/putOnHoldModal/interfaces"/>
import { ReasonCodeOperationDto } from "../shared/interfaces";

export interface PutOnHoldReasonsDto extends ReasonCodeOperationDto {
    putOnHoldEntityType: string
}